// Types
import { IIndexable } from "types/common";

export const netwrokRPCMapping: IIndexable = {
  "0x89": "https://polygon-rpc.com",
};

export const maticNetworkConfig = {
  chainId: "0x89",
  rpcUrls: ["https://polygon-rpc.com/"],
  chainName: "Polygon",
  nativeCurrency: {
    name: "MATIC",
    symbol: "MATIC",
    decimals: 18,
  },
  blockExplorerUrls: ["https://polygonscan.com/"],
};
